export default __webpack_public_path__ + "static/media/Rook's Cunning.e5cd26b7.jpg";